export const playlistsMock = {
    'hydra:member': [
        {
            '@type': 'ContentPlaylist',
            '@id': '/digital-retail/content-playlists/12dd741b-dd24-47b0-bf31-67e8966c0414',
            items: [
                {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        uuid: 'ContentPlaylistItemOutput/uuid',
                        position: 'ContentPlaylistItemOutput/position',
                        duration: 'ContentPlaylistItemOutput/duration',
                        distributedMedium:
                            'ContentPlaylistItemOutput/distributedMedium'
                    },
                    '@type': 'ContentPlaylistItem',
                    '@id': '/digital-retail/content-playlists/12dd741b-dd24-47b0-bf31-67e8966c0414/items/e2c329ff-d84e-4011-b6c8-d536428960f8',
                    uuid: 'e2c329ff-d84e-4011-b6c8-d536428960f8',
                    position: 0,
                    duration: 10,
                    distributedMedium: {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            uuid: 'DistributedVideoOutput/uuid',
                            vmsId: 'DistributedVideoOutput/vmsId',
                            type: 'DistributedVideoOutput/type',
                            fileInfo: 'DistributedVideoOutput/fileInfo',
                            createdAt: 'DistributedVideoOutput/createdAt',
                            updatedAt: 'DistributedVideoOutput/updatedAt'
                        },
                        '@type': 'DistributedVideo',
                        '@id': '/distribution/channels/14e645c4-1896-425b-8c60-59e94d53beaa/videos/adcc28e6-223d-4484-9a60-177d16d282f1',
                        uuid: 'adcc28e6-223d-4484-9a60-177d16d282f1',
                        vmsId: '5774',
                        type: 'video',
                        fileInfo: {
                            fileSource:
                                'https://audivmstest-a.akamaihd.net/retail/stage/5774/video-mtt-129-5774-6291.mp4',
                            fileSize: '2102163',
                            fileExtension: 'mp4',
                            fileName: 'preview-video-20767_previewvideo.mp4'
                        },
                        createdAt: {
                            date: '2021-08-17 16:08:19.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        updatedAt: {
                            date: '2021-08-17 16:08:19.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        thumbnail:
                            'https://audivmstest-a.akamaihd.net/retail/stage/5774/digital_retail_v2_5774_thumbnail.jpg',
                        fileType: 'mp4',
                        productKey: 'Produktschlüssel',
                        fileName: 'preview-video-20767_previewvideo.mp4',
                        prNumber: ['PR-Nummer', 'test1234'],
                        licences: [
                            {
                                expirationDate: {
                                    date: '2020-11-24 23:59:59.000000',
                                    timezone_type: 3,
                                    timezone: 'Europe/Berlin'
                                },
                                description: 'Comment',
                                title: 'Title'
                            }
                        ],
                        countries: ['DE'],
                        moduleTypes: ['MOD008'],
                        width: 288,
                        description: 'DRV2_1445',
                        height: 360,
                        usageFrom: {
                            date: '2020-11-24 09:57:00.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        fileSize: '2102163',
                        title: 'DRV2_1445',
                        duration: 10,
                        source: 'https://audivmstest-a.akamaihd.net/retail/stage/5774/video-mtt-129-5774-6291.mp4',
                        vehiclePart: [],
                        previewImage:
                            'https://audivmstest-a.akamaihd.net/retail/stage/5774/digital_retail_v2_5774_preview-image.jpg',
                        tags: ['ASF', 'Animation'],
                        carSpecifications: null,
                        usageTo: null
                    }
                }
            ],
            uuid: '12dd741b-dd24-47b0-bf31-67e8966c0414',
            title: 'sol-new-playlist',
            description: '',
            duration: 10,
            devices: [
                {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        uuid: 'DeviceOutput/uuid',
                        title: 'DeviceOutput/title',
                        deviceNumber: 'DeviceOutput/deviceNumber',
                        description: 'DeviceOutput/description',
                        playlists: 'DeviceOutput/playlists',
                        createdAt: 'DeviceOutput/createdAt',
                        updatedAt: 'DeviceOutput/updatedAt',
                        owner: 'DeviceOutput/owner',
                        dealership: 'DeviceOutput/dealership',
                        moduleType: 'DeviceOutput/moduleType',
                        moduleTypes: 'DeviceOutput/moduleTypes',
                        control: 'DeviceOutput/control',
                        deviceClass: 'DeviceOutput/deviceClass'
                    },
                    '@type': 'Device',
                    '@id': '/digital-retail/devices/5CD115CJTW',
                    uuid: '5CD115CJTW',
                    title: 'Snapo',
                    deviceNumber: '5CD115CJTW',
                    description: '',
                    playlists: [
                        {
                            '@context': {
                                '@vocab':
                                    'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                hydra: 'http://www.w3.org/ns/hydra/core#',
                                items: 'ContentPlaylistOutput/items',
                                uuid: 'ContentPlaylistOutput/uuid',
                                title: 'ContentPlaylistOutput/title',
                                description:
                                    'ContentPlaylistOutput/description',
                                duration: 'ContentPlaylistOutput/duration',
                                devices: 'ContentPlaylistOutput/devices',
                                dealerships:
                                    'ContentPlaylistOutput/dealerships',
                                moduleTypes:
                                    'ContentPlaylistOutput/moduleTypes',
                                countries: 'ContentPlaylistOutput/countries',
                                channelSlug:
                                    'ContentPlaylistOutput/channelSlug',
                                createdAt: 'ContentPlaylistOutput/createdAt',
                                updatedAt: 'ContentPlaylistOutput/updatedAt',
                                isGlobalFallback:
                                    'ContentPlaylistOutput/isGlobalFallback',
                                fallbackCountries:
                                    'ContentPlaylistOutput/fallbackCountries',
                                createdBy: 'ContentPlaylistOutput/createdBy',
                                updatedBy: 'ContentPlaylistOutput/updatedBy'
                            },
                            '@type': 'ContentPlaylist',
                            '@id': '/digital-retail/content-playlists/84aa99a0-8a74-46f1-a8db-6b91368a6374',
                            items: [
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        uuid: 'ContentPlaylistItemOutput/uuid',
                                        position:
                                            'ContentPlaylistItemOutput/position',
                                        duration:
                                            'ContentPlaylistItemOutput/duration',
                                        distributedMedium:
                                            'ContentPlaylistItemOutput/distributedMedium'
                                    },
                                    '@type': 'ContentPlaylistItem',
                                    '@id': '/digital-retail/content-playlists/84aa99a0-8a74-46f1-a8db-6b91368a6374/items/8689e181-bc4b-48ed-895e-602519c4d123',
                                    uuid: '8689e181-bc4b-48ed-895e-602519c4d123',
                                    position: 0,
                                    duration: 15,
                                    distributedMedium: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            uuid: 'DistributedVideoOutput/uuid',
                                            vmsId: 'DistributedVideoOutput/vmsId',
                                            type: 'DistributedVideoOutput/type',
                                            fileInfo:
                                                'DistributedVideoOutput/fileInfo',
                                            createdAt:
                                                'DistributedVideoOutput/createdAt',
                                            updatedAt:
                                                'DistributedVideoOutput/updatedAt'
                                        },
                                        '@type': 'DistributedVideo',
                                        '@id': '/distribution/channels/c9ba408e-3bf4-4a0b-8554-c62889f05e98/videos/cd7a7d10-07f8-46a9-9d27-31a937c03143',
                                        uuid: 'cd7a7d10-07f8-46a9-9d27-31a937c03143',
                                        vmsId: 0,
                                        type: 'video',
                                        fileInfo: {
                                            fileSource: '',
                                            fileSize: '34982519',
                                            fileExtension: 'mp4',
                                            fileName:
                                                'id.4 gtx launch tvc 15sec hd 16 to 9 de mp4.mp4'
                                        },
                                        createdAt: {
                                            date: '2021-10-21 09:24:16.000000',
                                            timezone_type: 3,
                                            timezone: 'Europe/Berlin'
                                        },
                                        updatedAt: {
                                            date: '2021-10-21 09:24:16.000000',
                                            timezone_type: 3,
                                            timezone: 'Europe/Berlin'
                                        },
                                        prNumber: [],
                                        title: 'ID.4 GTX Launch',
                                        assetID: '6020',
                                        videoLanguage: ['Deutsch'],
                                        videoType: 'MDB Import',
                                        ownerGroup: 'VW Retail',
                                        duration: 15,
                                        contractsLicenses: [],
                                        description:
                                            '15 Sekünder, Spot zum Launch des ID.4 GTX',
                                        tags: [
                                            'Design',
                                            'HBN_32314',
                                            'TRIM_GTX'
                                        ],
                                        videoContent: 'MDB Import',
                                        usageFrom: {
                                            date: '2021-06-07 00:00:00.000000',
                                            timezone_type: 3,
                                            timezone: 'Europe/Berlin'
                                        },
                                        usageTo: {
                                            date: '2022-06-06 00:00:00.000000',
                                            timezone_type: 3,
                                            timezone: 'Europe/Berlin'
                                        },
                                        licences: [
                                            {
                                                title: 'Limited / eingeschränkt',
                                                description: '',
                                                expirationDate: {
                                                    date: '2022-06-06 23:59:59.000000',
                                                    timezone_type: 3,
                                                    timezone: 'Europe/Berlin'
                                                }
                                            }
                                        ],
                                        countries: ['Deutschland'],
                                        imageFormats: {
                                            hdimage:
                                                'https://d34vc5ni64sdsm.cloudfront.net/stage/vw/video/6020/digital_retail_vw_6020_hdimage.jpg',
                                            thumbnail:
                                                'https://d34vc5ni64sdsm.cloudfront.net/stage/vw/video/6020/digital_retail_vw_6020_thumbnail.jpg',
                                            previewimage:
                                                'https://d34vc5ni64sdsm.cloudfront.net/stage/vw/video/6020/digital_retail_vw_6020_previewimage.jpg'
                                        },
                                        sourceFormats: {
                                            mtt: 'https://d34vc5ni64sdsm.cloudfront.net/stage/vw/video/6020/video-mtt-6020- id-4-gtx-launch-tvc-15sec-hd-16-to-9-de-mp4-6497.mp4'
                                        },
                                        specifications: null
                                    }
                                }
                            ],
                            uuid: '84aa99a0-8a74-46f1-a8db-6b91368a6374',
                            title: '[Duplicate] test pl 1',
                            description: '',
                            duration: 15,
                            dealerships: [
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        dealershipId:
                                            'DealershipOutput/dealershipId',
                                        title: 'DealershipOutput/title',
                                        address: 'DealershipOutput/address',
                                        massCredential:
                                            'DealershipOutput/massCredential',
                                        massAware: 'DealershipOutput/massAware',
                                        country: 'DealershipOutput/country',
                                        owner: 'DealershipOutput/owner',
                                        creator: 'DealershipOutput/creator',
                                        kvps: 'DealershipOutput/kvps'
                                    },
                                    '@type': 'Dealership',
                                    '@id': '/digital-retail/dealerships/DEU22263',
                                    dealershipId: 'DEU22263',
                                    title: 'DEU22263V - DEU22263',
                                    address: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            street: 'AddressOutput/street',
                                            city: 'AddressOutput/city',
                                            zipCode: 'AddressOutput/zipCode',
                                            state: 'AddressOutput/state'
                                        },
                                        '@type': 'AddressOutput',
                                        '@id': '_:8657',
                                        street: 'Wasserbreite 33 - 37',
                                        city: 'Bünde',
                                        zipCode: '32257',
                                        state: ''
                                    },
                                    massCredential: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            dealerId:
                                                'MassCredentialOutput/dealerId',
                                            activationToken:
                                                'MassCredentialOutput/activationToken'
                                        },
                                        '@type': 'MassCredentialOutput',
                                        '@id': '_:8661',
                                        dealerId: 'DEU22263',
                                        activationToken: 'MuretCroixThiais'
                                    },
                                    massAware: true,
                                    country: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            iso2: 'CountryOutput/iso2',
                                            iso3: 'CountryOutput/iso3',
                                            name: 'CountryOutput/name',
                                            capital: 'CountryOutput/capital',
                                            currency: 'CountryOutput/currency',
                                            phone: 'CountryOutput/phone'
                                        },
                                        '@type': 'Country',
                                        '@id': '/countries/DEU',
                                        iso2: 'DE',
                                        iso3: 'DEU',
                                        name: 'Germany',
                                        capital: 'Berlin',
                                        currency: 'EUR',
                                        phone: '49'
                                    },
                                    owner: 'DEU-0520 Wellergruppe',
                                    creator: 'system',
                                    kvps: 'DEU22263V'
                                }
                            ],
                            moduleTypes: [
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        uuid: 'ModuleTypeOutput/uuid',
                                        title: 'ModuleTypeOutput/title',
                                        slug: 'ModuleTypeOutput/slug',
                                        category: 'ModuleTypeOutput/category',
                                        code: 'ModuleTypeOutput/code'
                                    },
                                    '@type': 'ModuleType',
                                    '@id': '/module-types/presentation-element',
                                    uuid: 'bfac061d-a626-4328-942f-16bb2bf389bf',
                                    title: 'Presentation Element',
                                    slug: 'presentation-element',
                                    category: 'editorial',
                                    code: 'MOD001'
                                }
                            ],
                            countries: [],
                            createdAt: '2021-11-03 09:56:59',
                            updatedAt: '2021-11-03 09:56:59',
                            isGlobalFallback: false,
                            fallbackCountries: []
                        },
                        {
                            '@context': {
                                '@vocab':
                                    'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                hydra: 'http://www.w3.org/ns/hydra/core#',
                                items: 'ContentPlaylistOutput/items',
                                uuid: 'ContentPlaylistOutput/uuid',
                                title: 'ContentPlaylistOutput/title',
                                description:
                                    'ContentPlaylistOutput/description',
                                duration: 'ContentPlaylistOutput/duration',
                                devices: 'ContentPlaylistOutput/devices',
                                dealerships:
                                    'ContentPlaylistOutput/dealerships',
                                moduleTypes:
                                    'ContentPlaylistOutput/moduleTypes',
                                countries: 'ContentPlaylistOutput/countries',
                                channelSlug:
                                    'ContentPlaylistOutput/channelSlug',
                                createdAt: 'ContentPlaylistOutput/createdAt',
                                updatedAt: 'ContentPlaylistOutput/updatedAt',
                                isGlobalFallback:
                                    'ContentPlaylistOutput/isGlobalFallback',
                                fallbackCountries:
                                    'ContentPlaylistOutput/fallbackCountries',
                                createdBy: 'ContentPlaylistOutput/createdBy',
                                updatedBy: 'ContentPlaylistOutput/updatedBy'
                            },
                            '@type': 'ContentPlaylist',
                            '@id': '/digital-retail/content-playlists/12dd741b-dd24-47b0-bf31-67e8966c0414',
                            items: [
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        uuid: 'ContentPlaylistItemOutput/uuid',
                                        position:
                                            'ContentPlaylistItemOutput/position',
                                        duration:
                                            'ContentPlaylistItemOutput/duration',
                                        distributedMedium:
                                            'ContentPlaylistItemOutput/distributedMedium'
                                    },
                                    '@type': 'ContentPlaylistItem',
                                    '@id': '/digital-retail/content-playlists/12dd741b-dd24-47b0-bf31-67e8966c0414/items/e2c329ff-d84e-4011-b6c8-d536428960f8',
                                    uuid: 'e2c329ff-d84e-4011-b6c8-d536428960f8',
                                    position: 0,
                                    duration: 10,
                                    distributedMedium: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            uuid: 'DistributedVideoOutput/uuid',
                                            vmsId: 'DistributedVideoOutput/vmsId',
                                            type: 'DistributedVideoOutput/type',
                                            fileInfo:
                                                'DistributedVideoOutput/fileInfo',
                                            createdAt:
                                                'DistributedVideoOutput/createdAt',
                                            updatedAt:
                                                'DistributedVideoOutput/updatedAt'
                                        },
                                        '@type': 'DistributedVideo',
                                        '@id': '/distribution/channels/14e645c4-1896-425b-8c60-59e94d53beaa/videos/adcc28e6-223d-4484-9a60-177d16d282f1',
                                        uuid: 'adcc28e6-223d-4484-9a60-177d16d282f1',
                                        vmsId: '5774',
                                        type: 'video',
                                        fileInfo: {
                                            fileSource:
                                                'https://audivmstest-a.akamaihd.net/retail/stage/5774/video-mtt-129-5774-6291.mp4',
                                            fileSize: '2102163',
                                            fileExtension: 'mp4',
                                            fileName:
                                                'preview-video-20767_previewvideo.mp4'
                                        },
                                        createdAt: {
                                            date: '2021-08-17 16:08:19.000000',
                                            timezone_type: 3,
                                            timezone: 'Europe/Berlin'
                                        },
                                        updatedAt: {
                                            date: '2021-08-17 16:08:19.000000',
                                            timezone_type: 3,
                                            timezone: 'Europe/Berlin'
                                        },
                                        thumbnail:
                                            'https://audivmstest-a.akamaihd.net/retail/stage/5774/digital_retail_v2_5774_thumbnail.jpg',
                                        fileType: 'mp4',
                                        productKey: 'Produktschlüssel',
                                        fileName:
                                            'preview-video-20767_previewvideo.mp4',
                                        prNumber: ['PR-Nummer', 'test1234'],
                                        licences: [
                                            {
                                                expirationDate: {
                                                    date: '2020-11-24 23:59:59.000000',
                                                    timezone_type: 3,
                                                    timezone: 'Europe/Berlin'
                                                },
                                                description: 'Comment',
                                                title: 'Title'
                                            }
                                        ],
                                        countries: ['DE'],
                                        moduleTypes: ['MOD008'],
                                        width: 288,
                                        description: 'DRV2_1445',
                                        height: 360,
                                        usageFrom: {
                                            date: '2020-11-24 09:57:00.000000',
                                            timezone_type: 3,
                                            timezone: 'Europe/Berlin'
                                        },
                                        fileSize: '2102163',
                                        title: 'DRV2_1445',
                                        duration: 10,
                                        source: 'https://audivmstest-a.akamaihd.net/retail/stage/5774/video-mtt-129-5774-6291.mp4',
                                        vehiclePart: [],
                                        previewImage:
                                            'https://audivmstest-a.akamaihd.net/retail/stage/5774/digital_retail_v2_5774_preview-image.jpg',
                                        tags: ['ASF', 'Animation'],
                                        carSpecifications: null,
                                        usageTo: null
                                    }
                                }
                            ],
                            uuid: '12dd741b-dd24-47b0-bf31-67e8966c0414',
                            title: 'sol-new-playlist',
                            description: '',
                            duration: 10,
                            dealerships: [
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        dealershipId:
                                            'DealershipOutput/dealershipId',
                                        title: 'DealershipOutput/title',
                                        address: 'DealershipOutput/address',
                                        massCredential:
                                            'DealershipOutput/massCredential',
                                        massAware: 'DealershipOutput/massAware',
                                        country: 'DealershipOutput/country',
                                        owner: 'DealershipOutput/owner',
                                        creator: 'DealershipOutput/creator',
                                        kvps: 'DealershipOutput/kvps'
                                    },
                                    '@type': 'Dealership',
                                    '@id': '/digital-retail/dealerships/DEU00002',
                                    dealershipId: 'DEU00002',
                                    title: 'VWTEST01V - Dealer[DE2]',
                                    address: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            street: 'AddressOutput/street',
                                            city: 'AddressOutput/city',
                                            zipCode: 'AddressOutput/zipCode',
                                            state: 'AddressOutput/state'
                                        },
                                        '@type': 'AddressOutput',
                                        '@id': '_:8656',
                                        street: '',
                                        city: '',
                                        zipCode: '',
                                        state: ''
                                    },
                                    massCredential: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            dealerId:
                                                'MassCredentialOutput/dealerId',
                                            activationToken:
                                                'MassCredentialOutput/activationToken'
                                        },
                                        '@type': 'MassCredentialOutput',
                                        '@id': '_:8660',
                                        dealerId: 'DEU00002',
                                        activationToken: 'AjaccioChatouPar'
                                    },
                                    massAware: true,
                                    country: {
                                        '@context': {
                                            '@vocab':
                                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                            hydra: 'http://www.w3.org/ns/hydra/core#',
                                            iso2: 'CountryOutput/iso2',
                                            iso3: 'CountryOutput/iso3',
                                            name: 'CountryOutput/name',
                                            capital: 'CountryOutput/capital',
                                            currency: 'CountryOutput/currency',
                                            phone: 'CountryOutput/phone'
                                        },
                                        '@type': 'Country',
                                        '@id': '/countries/DEU',
                                        iso2: 'DE',
                                        iso3: 'DEU',
                                        name: 'Germany',
                                        capital: 'Berlin',
                                        currency: 'EUR',
                                        phone: '49'
                                    },
                                    owner: '',
                                    creator: '',
                                    kvps: 'VWTEST01V'
                                }
                            ],
                            moduleTypes: [
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        uuid: 'ModuleTypeOutput/uuid',
                                        title: 'ModuleTypeOutput/title',
                                        slug: 'ModuleTypeOutput/slug',
                                        category: 'ModuleTypeOutput/category',
                                        code: 'ModuleTypeOutput/code'
                                    },
                                    '@type': 'ModuleType',
                                    '@id': '/module-types/used-car',
                                    uuid: '96503cfb-7d89-4f27-8fe6-f2d2e3034ce4',
                                    title: 'Used Car',
                                    slug: 'used-car',
                                    category: 'editorial',
                                    code: 'MOD004'
                                },
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        uuid: 'ModuleTypeOutput/uuid',
                                        title: 'ModuleTypeOutput/title',
                                        slug: 'ModuleTypeOutput/slug',
                                        category: 'ModuleTypeOutput/category',
                                        code: 'ModuleTypeOutput/code'
                                    },
                                    '@type': 'ModuleType',
                                    '@id': '/module-types/mtt',
                                    uuid: 'bd5a23a6-25f9-4456-8101-2ab0e2129af3',
                                    title: 'MTT',
                                    slug: 'mtt',
                                    category: 'editorial',
                                    code: 'MOD006'
                                },
                                {
                                    '@context': {
                                        '@vocab':
                                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                        hydra: 'http://www.w3.org/ns/hydra/core#',
                                        uuid: 'ModuleTypeOutput/uuid',
                                        title: 'ModuleTypeOutput/title',
                                        slug: 'ModuleTypeOutput/slug',
                                        category: 'ModuleTypeOutput/category',
                                        code: 'ModuleTypeOutput/code'
                                    },
                                    '@type': 'ModuleType',
                                    '@id': '/module-types/presentation-element',
                                    uuid: 'bfac061d-a626-4328-942f-16bb2bf389bf',
                                    title: 'Presentation Element',
                                    slug: 'presentation-element',
                                    category: 'editorial',
                                    code: 'MOD001'
                                }
                            ],
                            countries: [],
                            createdAt: '2021-10-15 09:28:22',
                            updatedAt: '2021-10-15 09:45:23',
                            isGlobalFallback: true,
                            fallbackCountries: []
                        }
                    ],
                    createdAt: '2021-11-09 17:16:50',
                    updatedAt: '2021-11-24 10:51:54',
                    owner: 'e613810b-c68e-4933-80e4-d7d42c5ce2c5',
                    dealership: {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            dealershipId: 'DealershipOutput/dealershipId',
                            title: 'DealershipOutput/title',
                            address: 'DealershipOutput/address',
                            massCredential: 'DealershipOutput/massCredential',
                            massAware: 'DealershipOutput/massAware',
                            country: 'DealershipOutput/country',
                            owner: 'DealershipOutput/owner',
                            creator: 'DealershipOutput/creator',
                            kvps: 'DealershipOutput/kvps'
                        },
                        '@type': 'DealershipOutput',
                        '@id': '_:8632',
                        dealershipId: 'DEU22263',
                        title: 'DEU22263V - DEU22263',
                        address: {
                            '@context': {
                                '@vocab':
                                    'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                hydra: 'http://www.w3.org/ns/hydra/core#',
                                street: 'AddressOutput/street',
                                city: 'AddressOutput/city',
                                zipCode: 'AddressOutput/zipCode',
                                state: 'AddressOutput/state'
                            },
                            '@type': 'AddressOutput',
                            '@id': '_:7462',
                            street: 'Wasserbreite 33 - 37',
                            city: 'Bünde',
                            zipCode: '32257',
                            state: ''
                        },
                        massCredential: {
                            '@context': {
                                '@vocab':
                                    'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                hydra: 'http://www.w3.org/ns/hydra/core#',
                                dealerId: 'MassCredentialOutput/dealerId',
                                activationToken:
                                    'MassCredentialOutput/activationToken'
                            },
                            '@type': 'MassCredentialOutput',
                            '@id': '_:8633',
                            dealerId: 'DEU22263',
                            activationToken: 'MuretCroixThiais'
                        },
                        massAware: true,
                        country: {
                            '@context': {
                                '@vocab':
                                    'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                hydra: 'http://www.w3.org/ns/hydra/core#',
                                iso2: 'CountryOutput/iso2',
                                iso3: 'CountryOutput/iso3',
                                name: 'CountryOutput/name',
                                capital: 'CountryOutput/capital',
                                currency: 'CountryOutput/currency',
                                phone: 'CountryOutput/phone'
                            },
                            '@type': 'Country',
                            '@id': '/countries/DEU',
                            iso2: 'DE',
                            iso3: 'DEU',
                            name: 'Germany',
                            capital: 'Berlin',
                            currency: 'EUR',
                            phone: '49'
                        },
                        owner: 'DEU-0520 Wellergruppe',
                        creator: 'system',
                        kvps: 'DEU22263V'
                    },
                    moduleType: {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            uuid: 'ModuleTypeOutput/uuid',
                            title: 'ModuleTypeOutput/title',
                            slug: 'ModuleTypeOutput/slug',
                            category: 'ModuleTypeOutput/category',
                            code: 'ModuleTypeOutput/code'
                        },
                        '@type': 'ModuleType',
                        '@id': '/module-types/presentation-element',
                        uuid: 'bfac061d-a626-4328-942f-16bb2bf389bf',
                        title: 'Presentation Element',
                        slug: 'presentation-element',
                        category: 'editorial',
                        code: 'MOD001'
                    },
                    moduleTypes: [
                        {
                            '@context': {
                                '@vocab':
                                    'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                                hydra: 'http://www.w3.org/ns/hydra/core#',
                                uuid: 'ModuleTypeOutput/uuid',
                                title: 'ModuleTypeOutput/title',
                                slug: 'ModuleTypeOutput/slug',
                                category: 'ModuleTypeOutput/category',
                                code: 'ModuleTypeOutput/code'
                            },
                            '@type': 'ModuleType',
                            '@id': '/module-types/presentation-element',
                            uuid: 'bfac061d-a626-4328-942f-16bb2bf389bf',
                            title: 'Presentation Element',
                            slug: 'presentation-element',
                            category: 'editorial',
                            code: 'MOD001'
                        }
                    ],
                    control: { action: 'play' },
                    deviceClass: 'CHROMEBOX'
                }
            ],
            dealerships: [
                {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        dealershipId: 'DealershipOutput/dealershipId',
                        title: 'DealershipOutput/title',
                        address: 'DealershipOutput/address',
                        massCredential: 'DealershipOutput/massCredential',
                        massAware: 'DealershipOutput/massAware',
                        country: 'DealershipOutput/country',
                        owner: 'DealershipOutput/owner',
                        creator: 'DealershipOutput/creator',
                        kvps: 'DealershipOutput/kvps'
                    },
                    '@type': 'Dealership',
                    '@id': '/digital-retail/dealerships/DEU00002',
                    dealershipId: 'DEU00002',
                    title: 'VWTEST01V - Dealer[DE2]',
                    address: {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            street: 'AddressOutput/street',
                            city: 'AddressOutput/city',
                            zipCode: 'AddressOutput/zipCode',
                            state: 'AddressOutput/state'
                        },
                        '@type': 'AddressOutput',
                        '@id': '_:8634',
                        street: '',
                        city: '',
                        zipCode: '',
                        state: ''
                    },
                    massCredential: {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            dealerId: 'MassCredentialOutput/dealerId',
                            activationToken:
                                'MassCredentialOutput/activationToken'
                        },
                        '@type': 'MassCredentialOutput',
                        '@id': '_:8632',
                        dealerId: 'DEU00002',
                        activationToken: 'AjaccioChatouPar'
                    },
                    massAware: true,
                    country: {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            iso2: 'CountryOutput/iso2',
                            iso3: 'CountryOutput/iso3',
                            name: 'CountryOutput/name',
                            capital: 'CountryOutput/capital',
                            currency: 'CountryOutput/currency',
                            phone: 'CountryOutput/phone'
                        },
                        '@type': 'Country',
                        '@id': '/countries/DEU',
                        iso2: 'DE',
                        iso3: 'DEU',
                        name: 'Germany',
                        capital: 'Berlin',
                        currency: 'EUR',
                        phone: '49'
                    },
                    owner: '',
                    creator: '',
                    kvps: 'VWTEST01V'
                }
            ],
            moduleTypes: [
                {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        uuid: 'ModuleTypeOutput/uuid',
                        title: 'ModuleTypeOutput/title',
                        slug: 'ModuleTypeOutput/slug',
                        category: 'ModuleTypeOutput/category',
                        code: 'ModuleTypeOutput/code'
                    },
                    '@type': 'ModuleType',
                    '@id': '/module-types/used-car',
                    uuid: '96503cfb-7d89-4f27-8fe6-f2d2e3034ce4',
                    title: 'Used Car',
                    slug: 'used-car',
                    category: 'editorial',
                    code: 'MOD004'
                },
                {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        uuid: 'ModuleTypeOutput/uuid',
                        title: 'ModuleTypeOutput/title',
                        slug: 'ModuleTypeOutput/slug',
                        category: 'ModuleTypeOutput/category',
                        code: 'ModuleTypeOutput/code'
                    },
                    '@type': 'ModuleType',
                    '@id': '/module-types/mtt',
                    uuid: 'bd5a23a6-25f9-4456-8101-2ab0e2129af3',
                    title: 'MTT',
                    slug: 'mtt',
                    category: 'editorial',
                    code: 'MOD006'
                },
                {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        uuid: 'ModuleTypeOutput/uuid',
                        title: 'ModuleTypeOutput/title',
                        slug: 'ModuleTypeOutput/slug',
                        category: 'ModuleTypeOutput/category',
                        code: 'ModuleTypeOutput/code'
                    },
                    '@type': 'ModuleType',
                    '@id': '/module-types/presentation-element',
                    uuid: 'bfac061d-a626-4328-942f-16bb2bf389bf',
                    title: 'Presentation Element',
                    slug: 'presentation-element',
                    category: 'editorial',
                    code: 'MOD001'
                }
            ],
            countries: [],
            createdAt: '2021-10-15 09:28:22',
            updatedAt: '2021-10-15 09:45:23',
            isGlobalFallback: true,
            fallbackCountries: [],
            createdBy: {
                '@context': {
                    '@vocab':
                        'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                    hydra: 'http://www.w3.org/ns/hydra/core#',
                    uuid: 'UserOutput/uuid',
                    username: 'UserOutput/username',
                    favoritesAmount: 'UserOutput/favoritesAmount',
                    firstname: 'UserOutput/firstname',
                    lastname: 'UserOutput/lastname',
                    showTutorial: 'UserOutput/showTutorial',
                    vmsId: 'UserOutput/vmsId',
                    email: 'UserOutput/email',
                    originCountry: 'UserOutput/originCountry',
                    uploadWizardAssetData: 'UserOutput/uploadWizardAssetData',
                    collectionShares: 'UserOutput/collectionShares',
                    mmdsCoreRoles: 'UserOutput/mmdsCoreRoles',
                    sharedCountries: 'UserOutput/sharedCountries'
                },
                '@type': 'User',
                '@id': '/users/394e67de-bb9e-4048-b5ce-13eb1b78382a',
                uuid: '394e67de-bb9e-4048-b5ce-13eb1b78382a',
                username: 'sampo.lahtinen',
                favoritesAmount: 4,
                firstname: 'Sampo',
                lastname: 'Lahtinen',
                showTutorial: false,
                vmsId: 1734,
                email: 'sampo.lahtinen@endava.com',
                originCountry: {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        iso2: 'CountryOutput/iso2',
                        iso3: 'CountryOutput/iso3',
                        name: 'CountryOutput/name',
                        capital: 'CountryOutput/capital',
                        currency: 'CountryOutput/currency',
                        phone: 'CountryOutput/phone'
                    },
                    '@type': 'Country',
                    '@id': '/countries/DEU',
                    iso2: 'DE',
                    iso3: 'DEU',
                    name: 'Germany',
                    capital: 'Berlin',
                    currency: 'EUR',
                    phone: '49'
                },
                uploadWizardAssetData: [],
                collectionShares: [],
                mmdsCoreRoles: ['ROLE_SUPER_ADMIN'],
                sharedCountries: [
                    {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            iso2: 'CountryOutput/iso2',
                            iso3: 'CountryOutput/iso3',
                            name: 'CountryOutput/name',
                            capital: 'CountryOutput/capital',
                            currency: 'CountryOutput/currency',
                            phone: 'CountryOutput/phone'
                        },
                        '@type': 'Country',
                        '@id': '/countries/DEU',
                        iso2: 'DE',
                        iso3: 'DEU',
                        name: 'Germany',
                        capital: 'Berlin',
                        currency: 'EUR',
                        phone: '49'
                    },
                    {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            iso2: 'CountryOutput/iso2',
                            iso3: 'CountryOutput/iso3',
                            name: 'CountryOutput/name',
                            capital: 'CountryOutput/capital',
                            currency: 'CountryOutput/currency',
                            phone: 'CountryOutput/phone'
                        },
                        '@type': 'Country',
                        '@id': '/countries/FIN',
                        iso2: 'FI',
                        iso3: 'FIN',
                        name: 'Finland',
                        capital: 'Helsinki',
                        currency: 'EUR',
                        phone: '358'
                    }
                ]
            },
            updatedBy: {
                '@context': {
                    '@vocab':
                        'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                    hydra: 'http://www.w3.org/ns/hydra/core#',
                    uuid: 'UserOutput/uuid',
                    username: 'UserOutput/username',
                    favoritesAmount: 'UserOutput/favoritesAmount',
                    firstname: 'UserOutput/firstname',
                    lastname: 'UserOutput/lastname',
                    showTutorial: 'UserOutput/showTutorial',
                    vmsId: 'UserOutput/vmsId',
                    email: 'UserOutput/email',
                    originCountry: 'UserOutput/originCountry',
                    uploadWizardAssetData: 'UserOutput/uploadWizardAssetData',
                    collectionShares: 'UserOutput/collectionShares',
                    mmdsCoreRoles: 'UserOutput/mmdsCoreRoles',
                    sharedCountries: 'UserOutput/sharedCountries'
                },
                '@type': 'User',
                '@id': '/users/394e67de-bb9e-4048-b5ce-13eb1b78382a',
                uuid: '394e67de-bb9e-4048-b5ce-13eb1b78382a',
                username: 'sampo.lahtinen',
                favoritesAmount: 4,
                firstname: 'Sampo',
                lastname: 'Lahtinen',
                showTutorial: false,
                vmsId: 1734,
                email: 'sampo.lahtinen@endava.com',
                originCountry: {
                    '@context': {
                        '@vocab':
                            'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                        hydra: 'http://www.w3.org/ns/hydra/core#',
                        iso2: 'CountryOutput/iso2',
                        iso3: 'CountryOutput/iso3',
                        name: 'CountryOutput/name',
                        capital: 'CountryOutput/capital',
                        currency: 'CountryOutput/currency',
                        phone: 'CountryOutput/phone'
                    },
                    '@type': 'Country',
                    '@id': '/countries/DEU',
                    iso2: 'DE',
                    iso3: 'DEU',
                    name: 'Germany',
                    capital: 'Berlin',
                    currency: 'EUR',
                    phone: '49'
                },
                uploadWizardAssetData: [],
                collectionShares: [],
                mmdsCoreRoles: ['ROLE_SUPER_ADMIN'],
                sharedCountries: [
                    {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            iso2: 'CountryOutput/iso2',
                            iso3: 'CountryOutput/iso3',
                            name: 'CountryOutput/name',
                            capital: 'CountryOutput/capital',
                            currency: 'CountryOutput/currency',
                            phone: 'CountryOutput/phone'
                        },
                        '@type': 'Country',
                        '@id': '/countries/DEU',
                        iso2: 'DE',
                        iso3: 'DEU',
                        name: 'Germany',
                        capital: 'Berlin',
                        currency: 'EUR',
                        phone: '49'
                    },
                    {
                        '@context': {
                            '@vocab':
                                'http://api-stage.audi-vmrs.endava.berlin/docs.jsonld#',
                            hydra: 'http://www.w3.org/ns/hydra/core#',
                            iso2: 'CountryOutput/iso2',
                            iso3: 'CountryOutput/iso3',
                            name: 'CountryOutput/name',
                            capital: 'CountryOutput/capital',
                            currency: 'CountryOutput/currency',
                            phone: 'CountryOutput/phone'
                        },
                        '@type': 'Country',
                        '@id': '/countries/FIN',
                        iso2: 'FI',
                        iso3: 'FIN',
                        name: 'Finland',
                        capital: 'Helsinki',
                        currency: 'EUR',
                        phone: '358'
                    }
                ]
            }
        },
        {
            '@id': '/digital-retail/content-playlists/6e4486cc-433a-4231-b815-0689686acf1d',
            items: [
                {
                    '@id': '/digital-retail/content-playlists/6e4486cc-433a-4231-b815-0689686acf1d/items/744e29ab-3e76-4c53-9416-9ca75b935139',
                    uuid: '744e29ab-3e76-4c53-9416-9ca75b935139',
                    position: 0,
                    duration: 15,
                    distributedMedium: {
                        '@id': '/distribution/channels/14e645c4-1896-425b-8c60-59e94d53beaa/images/98fa11f0-de08-4ec0-b7d6-2dd67a713a5a',
                        uuid: '98fa11f0-de08-4ec0-b7d6-2dd67a713a5a',
                        vmsId: 0,
                        type: 'image',
                        fileInfo: {
                            fileSource:
                                'https://audivmstest-a.akamaihd.net/retail/stage/images/881_source-image-881.tiff',
                            fileSize: '181081328',
                            fileExtension: 'tiff',
                            fileName: 'source-image-5162.tiff'
                        },
                        createdAt: {
                            date: '2021-03-23 09:18:01.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        updatedAt: {
                            date: '2021-03-23 09:18:01.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        vehiclePart: [],
                        tags: [],
                        title: 'tiff to mdb stage',
                        fileName: 'source-image-5162.tiff',
                        sharedCountries: [],
                        moduleTypes: [],
                        prNumber: [],
                        licences: [
                            {
                                title: 'Free / Frei',
                                expirationDate: {
                                    date: '2021-03-23 09:18:01.000000',
                                    timezone_type: 3,
                                    timezone: 'Europe/Berlin'
                                },
                                description:
                                    'AUDI AG’s importers are solely responsible for the legal conformity of any kind of marketing materials and have to ensure that they do not violate any laws in their respective country. Therefore, the material provided needs to be checked to that effect by the importers. Unrestricted: There are no time limits or geographical restrictions on the use of high-resolution data. Any editing which exceeds the scope of ordinary requirements shall require the prior consent of the photographer. Only minor changes, e.g. vehicle registration plates, shall not require approval.'
                            }
                        ],
                        previewImage:
                            'https://audivmstest-a.akamaihd.net/retail/stage/images/881_preview-image-881.png',
                        fileType: 'tiff',
                        source: 'https://audivmstest-a.akamaihd.net/retail/stage/images/881_source-image-881.tiff',
                        height: 10048,
                        width: 12003,
                        fileSize: '181081328',
                        thumbnail:
                            'https://audivmstest-a.akamaihd.net/retail/stage/images/881_thumbnail-881.png',
                        description: null,
                        productKey: null,
                        resolution: null,
                        carSpecifications: null,
                        duration: null,
                        usageFrom: null,
                        usageTo: null
                    }
                }
            ],
            title: '[Duplicate] dpk--2',
            description: 'test',
            duration: 15,
            devices: [],
            dealerships: [
                {
                    '@id': '/digital-retail/dealerships/DEU00002'
                }
            ],
            moduleTypes: [
                {
                    '@id': '/module-types/presentation-element'
                },
                {
                    '@id': '/module-types/other-modules'
                },
                {
                    '@id': '/module-types/cpl'
                }
            ],
            countries: [],
            createdAt: '2021-11-03 10:34:03',
            updatedAt: '2021-11-03 10:34:03',
            isGlobalFallback: false,
            fallbackCountries: [],
            createdBy: {
                '@id': '/users/a9a68a7b-f992-42ab-a501-32f55778490b',
                username: 'tester.four',
                firstname: 'Tester',
                lastname: 'Four',
                mmdsCoreRoles: ['ROLE_SUPER_EDITOR']
            },
            updatedBy: {
                '@id': '/users/a9a68a7b-f992-42ab-a501-32f55778490b',
                username: 'tester.four',
                firstname: 'Tester',
                lastname: 'Four',
                mmdsCoreRoles: ['ROLE_SUPER_EDITOR']
            }
        },
        {
            '@id': '/digital-retail/content-playlists/f5fe867d-8782-4d20-8b09-92bff103b6dd',
            items: [
                {
                    '@id': '/digital-retail/content-playlists/f5fe867d-8782-4d20-8b09-92bff103b6dd/items/473b3621-e372-415a-b36e-b58d5fd55400',
                    uuid: '473b3621-e372-415a-b36e-b58d5fd55400',
                    position: 0,
                    duration: 10,
                    distributedMedium: {
                        '@id': '/distribution/channels/14e645c4-1896-425b-8c60-59e94d53beaa/videos/adcc28e6-223d-4484-9a60-177d16d282f1',
                        uuid: 'adcc28e6-223d-4484-9a60-177d16d282f1',
                        vmsId: '5774',
                        type: 'video',
                        fileInfo: {
                            fileSource:
                                'https://audivmstest-a.akamaihd.net/retail/stage/5774/video-mtt-129-5774-6291.mp4',
                            fileSize: '2102163',
                            fileExtension: 'mp4',
                            fileName: 'preview-video-20767_previewvideo.mp4'
                        },
                        createdAt: {
                            date: '2021-08-17 16:08:19.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        updatedAt: {
                            date: '2021-08-17 16:08:19.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        thumbnail:
                            'https://audivmstest-a.akamaihd.net/retail/stage/5774/digital_retail_v2_5774_thumbnail.jpg',
                        fileType: 'mp4',
                        productKey: 'Produktschlüssel',
                        fileName: 'preview-video-20767_previewvideo.mp4',
                        prNumber: ['PR-Nummer', 'test1234'],
                        licences: [
                            {
                                expirationDate: {
                                    date: '2020-11-24 23:59:59.000000',
                                    timezone_type: 3,
                                    timezone: 'Europe/Berlin'
                                },
                                description: 'Comment',
                                title: 'Title'
                            }
                        ],
                        countries: ['DE'],
                        moduleTypes: ['MOD008'],
                        width: 288,
                        description: 'DRV2_1445',
                        height: 360,
                        usageFrom: {
                            date: '2020-11-24 09:57:00.000000',
                            timezone_type: 3,
                            timezone: 'Europe/Berlin'
                        },
                        fileSize: '2102163',
                        title: 'DRV2_1445',
                        duration: 10,
                        source: 'https://audivmstest-a.akamaihd.net/retail/stage/5774/video-mtt-129-5774-6291.mp4',
                        vehiclePart: [],
                        previewImage:
                            'https://audivmstest-a.akamaihd.net/retail/stage/5774/digital_retail_v2_5774_preview-image.jpg',
                        tags: ['ASF', 'Animation'],
                        carSpecifications: null,
                        usageTo: null
                    }
                }
            ],
            title: '[Duplicate] sol-new-playlist',
            description: '',
            duration: 10,
            devices: [],
            dealerships: [
                {
                    '@id': '/digital-retail/dealerships/DEU00002'
                }
            ],
            moduleTypes: [
                {
                    '@id': '/module-types/used-car'
                },
                {
                    '@id': '/module-types/mtt'
                },
                {
                    '@id': '/module-types/presentation-element'
                }
            ],
            countries: [],
            createdAt: '2021-11-03 10:31:59',
            updatedAt: '2021-11-03 10:31:59',
            isGlobalFallback: false,
            fallbackCountries: [],
            createdBy: {
                '@id': '/users/a9a68a7b-f992-42ab-a501-32f55778490b',
                username: 'tester.four',
                firstname: 'Tester',
                lastname: 'Four',
                mmdsCoreRoles: ['ROLE_SUPER_EDITOR']
            },
            updatedBy: {
                '@id': '/users/a9a68a7b-f992-42ab-a501-32f55778490b',
                username: 'tester.four',
                firstname: 'Tester',
                lastname: 'Four',
                mmdsCoreRoles: ['ROLE_SUPER_EDITOR']
            }
        }
    ]
};
